export default 'booking';
